import React from 'react';
import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <>
    <rect width="24" height="24" rx="12" fill="white" />
    <path
      d="M20.1897 17.6255C20.2638 17.8735 20.4121 18.0648 20.6839 18.2136H20.6778C20.8755 18.334 21.6787 18.497 22 18.5395V18.9929H15.6978V18.5395C16.0191 18.5041 16.9521 18.3978 17.1992 18.2561C17.2301 18.2419 17.2548 18.2277 17.2796 18.2065C17.5638 17.9798 17.7368 17.6964 17.7368 17.3279V9.2156L12.3367 19H10.0074V9.22977C10.0074 9.22977 6.17051 16.1731 5.67622 17.0729C5.58972 17.2288 5.54029 17.4059 5.56501 17.5901C5.60208 17.8806 5.75654 18.001 5.97279 18.1073C6.25083 18.2348 6.54122 18.3198 6.83779 18.3907C7.16525 18.4616 7.49272 18.5041 7.82018 18.5466V19H1.99998V18.5466C1.99998 18.5466 2.87733 18.4545 3.16773 18.3694C4.20572 18.0577 4.56408 17.2004 4.72472 16.9312L11.5706 5.00001H12.4541V16.9312L19.2938 5.00001H20.1773V17.5122C20.1773 17.5547 20.1897 17.5901 20.1897 17.6255Z"
      fill="#124A7E"
    />
  </>,
  'HoustonMethodist'
);
